<template>
  <div id="brassicadb-home">
    <p style="text-align: center; padding-top: 20px; color: #407338;font-size: 30px"><b>Brassicaceae Database</b></p>
    <div class="home-introduction">
      <div>
        <!-- <a style="color: #275015;font-size: 18px">
          • The <b><i>Brassica</i> Database (BRAD)</b> was previously a searchable
          Database of <i>Brassiceae</i> genomic data hosted on the website
          "<a href="http://brassicadb.org" style="color: #275015;text-decoration: none" target="_blank">
          http://brassicadb.org</a>".
          For the policy and safety reasons, we moved it to the new website
          "<a href="http://brassicadb.cn" style="color: #275015;text-decoration: none">
            http://brassicadb.cn
          </a>"
          It is now a new database which includes not only newly released
          genome sequences of <i>Brassiceae</i> species, but also published
          genomic data of most other <i>Brassicaceae</i> species.<br/>
        </a>
        <a style="color: #275015;font-size: 18px">
          In total,we provided services for 35 genomes or 
          genome versions from 24 species (refer to
          <a href="http://brassicadb.cn/#/SpeciesInfo/" style="color: #275015;text-decoration: none">
            <b>Species info</b>
          </a>). The genomic data included
          mainly genome assemblies, predicted gene models, gene annotations.
          These data can be browsed in JBrowse or seached in BLAST. We continue
          offering the featured service of the searching for syntenic genes,
          which are generated based on their syntenic relationships to the
          genes in <i>Arabidopsis</i>. We will keep on updating the database with
          newly released high-quality reference genomes.
        </a> -->
        <ul>
          <li class="introduction-li">
            <a style="color: #275015;font-size: 18px">
              The <b>Brassicaceae Database (BRAD)</b> was previously a searchable
              Database of <i>Brassiceae</i> genomic data hosted on the website
              "<a href="http://brassicadb.org" style="color: #275015" target="_blank">
              http://brassicadb.org</a>". 
              For the policy and safety reasons, we moved it to the new website
              "<a href="http://brassicadb.cn" style="color: #275015">
                http://brassicadb.cn
              </a>". 
              It is now a new database which includes not only newly released
              genome sequences of <i>Brassiceae</i> species, but also published
              genomic data of most other Brassicaceae species.<br/>
            </a>
          </li>
          <li class="introduction-li">
            <a style="color: #275015;font-size: 18px">
              In total, we provided services for 41 genomes or 
              genome versions from 26 species (refer to
              <a href="http://brassicadb.cn/#/SpeciesInfo/" style="color: #275015">
                <b>Species info</b>
              </a>). The genomic data include
              mainly genome assemblies, predicted gene models and gene annotations.
            </a>
          </li>
          <li class="introduction-li">
            <a style="color: #275015;font-size: 18px">
              These data can be browsed in JBrowse or searched in BLAST. We continue
              offering the featured service of searching for syntenic genes, 
              which are generated based on their syntenic relationships to the
              genes in <i>Arabidopsis thaliana</i>.
            </a>
          </li>
          <li class="introduction-li">
            <a style="color: #275015;font-size: 18px">
              We will regularly update the database with
              newly released high-quality reference genomes.
            </a>  
          </li>
        </ul>
        <br/>
        <a style="color: #2440B3;font-size: 14px">
          <b>Cite BRAD as "
          <a href="https://academic.oup.com/nar/advance-article/doi/10.1093/nar/gkab1057/6424756" target="_blank" style="color: #2440B3;">
            Chen H, Wang T, He X, Cai X, Lin R, Liang J, Wu J, King G, Wang X. <i>Nucleic Acids Res</i>. Volume 50, Issue D1, 7 January 2022, Pages D1432–D1441
          </a>".</b>
        </a>
        <div style="margin-top:30px; height: 150px; text-align: center">
          <div class="function_page" style="float: left; width: 150px;">
            <img src="../assets/img/Syntenic_genes.png" style="width: 150px; height: 94px;" @click.self="to_syntenic_gene" title="Search Syntenic gene @ Subgenome">
            <br/>
            <a style="color: #275015;font-size: 15px">Syntenic Gene @ Subgenomes</a>
          </div>
          <div class="function_page" style="float: left; width: 150px; margin-left: 50px; text-align: center">
            <img src="../assets/img/MicroSynteny.png" style="width: 150px; height: 94px;" @click.self="to_microsynteny" title="Search MicroSynteny">
            <br/>
            <a style="color: #275015;font-size: 15px">MicroSynteny</a>
          </div>
          <div class="function_page" style="float: left; width: 150px; margin-left: 50px; text-align: center">
            <img src="../assets/img/Polymorph.png" style="width: 150px; height: 94px;" @click.self="to_polymorph" title="Search Polymorph">
            <br/>
            <a style="color: #275015;font-size: 15px;">Polymorph</a>
          </div>
          <div class="function_page" style="float: left; width: 150px; margin-left: 50px; text-align: center">
            <img src="../assets/img/BrapaLeafCelleFP.png" style="width: 150px; height: 94px;" @click.self="to_brapaLeafcellefp" title="Search BrapaLeafCelleFP">
            <br/>
            <a style="color: #275015;font-size: 15px;">BrapaLeafCelleFP</a>
          </div>
        </div>

      </div>
      <div class="recent-progress">
        <h3 style="color: #275015; font-size: 24px">Publications:</h3>
        <div v-for="(news, index) in news_list.slice((currentPage- 1)*5,currentPage*5)" :key="index">
          <ul>
            <template>
              <li class="publication_ul" style="margin: 20px 0px">
                <a :href="news.news_link" target="_blank" style="color: #275015">{{news.news_brief}}</a>
              </li>
            </template>
          </ul>
        </div>
        <div class="control">
          <el-pagination
              layout="total, prev, pager, next, jumper"
              :page-size="5"
              @current-change="current_change"
              :current-page.sync="currentPage"
              :pager-count="5"
              :total="news_list.length">
          </el-pagination>
        </div>
      </div>
    </div>
    <div class="news">
      <h3 style="color: #275015">News</h3>
      <!-- <a style="color:#275015;" href="https://ivf.caas.cn//xwdt/rczp/bae864aa8efc44c5b4879a20e75ff433.htm" target="_blank">
        Post-doctoral Program.<br/><br/>
      </a> -->
      <a style="color:#275015;" href="http://brassicadb.cn/#/ProteinStructure/" target="_blank">
        Protein structures of some genes in the <i>B. rapa</i> version 3.5 genome have been released<br/><br/>
      </a>
      <a style="color: #275015">
        Reference genome annotation for Brassica rapa Chiifu-401-42 has been updated to version V 3.5, </a>
        <a href="https://www.frontiersin.org/articles/10.3389/fpls.2022.841618/full" target="_blank">
        Improved reference genome annotation of Brassica rapa by PacBio RNA sequencing.</a><br/><br/>
      <a>BRAD V3.0 has been published in Nucleic Acids Research, </a>
      <a href="https://academic.oup.com/nar/advance-article/doi/10.1093/nar/gkab1057/6424756" target="_blank">
        BRAD V3.0: an upgraded Brassicaceae database.
      </a>
      <br/><br/>
      <a><b>Group Leader</b><br/>
        Xiaowu Wang<br/>
        E-mail:
      </a>
      <a style="font-size:14px;color: #275015">wangxiaowu@caas.cn</a><br/><br/>
      <a style="color: #275015"><b>Website Developer</b><br/>Haixu Chen<br/>E-mail:<br/></a>
      <a style="font-size:14px;color: #275015">caas_ivf_chenhaixu@163.com</a>
      <div style="margin-top: 50px">
        <!-- <a href="https://www.bfcounter.vip/"><img src="https://www.bfcounter.vip/generatepic?userid=9aa0a980-5aac-46c2-ac3d-2d9bfbc899d5" alt="Page Counter" border="0"></a> -->
        <a href="https://www.revolvermaps.com/livestats/5nm3q94lz76/"><img src="//rf.revolvermaps.com/h/m/a/0/ff0000/128/0/5nm3q94lz76.png" width="100" height="50" alt="Map" style="border:0;"></a>
      </div>
    </div>
    <!-- <div id="support-introduction">
      <div style="margin: 10px auto;width: 700px;">
        <div class="support-img">
          <img style="float: left" src="../assets/img/zsbd.png">
          <img src="../assets/img/ivf_logo.png" style="float: left;margin-top: 10px;margin-left: 10px">
        </div>
        <div class="support-text">
          <a title="Institute of Vegetables and Flowers" href="http://ivf.caas.cn/" target="_blank" style="text-decoration: none;color: #275015">Key Laboratory of Biology and Genetic Improvement of Horticultural Crops,<br/></a>
          <a title="Institute of Vegetables and Flowers" href="http://ivf.caas.cn/" target="_blank" style="text-decoration: none;color: #275015">Ministry of Agriculture, P.R.China,<br/></a>
          <a title="Institute of Vegetables and Flowers" href="http://ivf.caas.cn/" target="_blank" style="text-decoration: none;color: #275015">Institute of Vegetables and Flowers,<br/></a>
          <a title="The Chinese Academy of Agricultural Sciences" href="http://www.caas.cn/" target="_blank" style="text-decoration: none;color: #275015">Chinese Academy of Agricultural Sciences</a>
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
import axios from 'axios';
export default {
  name: 'Home',
  data() {
    return {
      news_list: {},
      currentPage:1,
    }
  },
  mounted() {
    this.judgeStyle();
    this.get_news_list()
  },
  components:{

  },
  methods:{
    judgeStyle() {
      // console.log("OKOKOOK3")
      document.getElementsByTagName('html')[0].style.height = '';
      document.getElementsByTagName('body')[0].style.height = '';
    },
    current_change(currentPage) {
      this.currentPage = currentPage
    },
    to_syntenic_gene() {
      this.$router.push({path: '/syntenic-gene/'})
    },
    to_microsynteny() {
      this.$router.push({path: '/RegionMicroSynteny/'})
    },
    to_polymorph() {
      this.$router.push({path: '/Polymorph/'})
    },
    to_brapaLeafcellefp() {
      this.$router.push({path: '/BrapaLeafCelleFP/'})
    },
    get_news_list() {
      axios({
        url:'http://brassicadb.cn:8001/api/get-news-list/',
        type:'json',
        method:'get',
      }).then((res)=>{
        // console.log(res.data)
        this.news_list = res.data
      })
    }
  }
}

</script>

<style>
  #brassicadb-home {
    margin: 0 auto;
    /*border: solid 1px #000000;*/
    /*background: coral;*/
    overflow:auto;
    /*height: 300px;*/
  }

  #brassicadb-home .home-introduction {
    float: left;
    width: 800px;
    height: 1100px;
    /* border: solid 1px #000000; */
    margin-top: 20px;
    margin-left: 60px;
    margin-right: 0px;
    /*height: 100px;*/
  }

  #brassicadb-home .home-introduction .recent-progress {
    height: 300px;
    margin-top: 60px;
    /*border: 1px solid #000000;*/
  }

  #brassicadb-home .home-introduction .recent-progress .control {
    margin: 20px auto;
    width: 400px;
  }

  #brassicadb-home .home-introduction .recent-progress .publication_ul::marker {
    color: #275015;
  }

  #brassicadb-home .news {
    float: right;
    width: 210px;
    height: 1100px;
    /* border: solid 1px #000000; */
    margin-top: 20px;
    margin-right: 60px;
    /*height: 100px;*/
  }

  #brassicadb-home #support-introduction {
    width: 1080px;
    margin: 40px 60px;
    height: 90px;
    /*border: solid 1px #000000;*/
    float: left;
  }

  #brassicadb-home #support-introduction .support-img {
    margin: 0px ;
    width: 140px;
    /*border: 1px solid #000000;*/
  }

  #brassicadb-home #support-introduction .support-text {
    margin-left: 150px;
  }

  .home-introduction .introduction-li {
    margin-bottom: 10px;
  }

  .home-introduction .introduction-li::marker {
    font-size: 20px;
    color: #275015;
  }

  .home-introduction .function_page {
    cursor: pointer;
    transition: all 0.6s;
  }

  .home-introduction .function_page:hover {
    transform: scale(1.5);
  }  

</style>
